const actions = {

};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/notifications/actions.js